$(document).ready(function(){ 
 var Product_array = [];  
 $(document).on('click', '.itg_featured_collection button.productAddtocart', function(evt) {
        evt.preventDefault(); var $this = $(this); 
        $('.pack-drawer--root[data-drawer-target]').addClass('is__visible'); 
         var productCard = $this.closest('product-card');
         var productImage = productCard.find('img').attr('src');
         var productTitle = productCard.find('[data-name="title"] a').attr('title');
         var productUrl = productCard.find('[data-name="title"] a').attr('href');
         var productPrice = productCard.find('product-price [data-aid="regular-price"]').text(); 
         var variantId = productCard.find('input.product-variant-id').val();
         var itemPrice = productCard.find('product-price').attr('price'); 
         var productId = $this.data('product-id');
         var productSku = $this.data('product-sku');
         var productAddOptions = ''; 
          if (productCard.find('select.selectColorOption').val() != undefined) {
           productAddOptions = productCard.find('select.selectColorOption').val();
         }  
            if($this.hasClass('is__active')) { 
               $(document).find('#packdrawerListRoot li.pack-drawerList-items').each(function(){
                  var ThisId = $(this).attr('data-variantid');
                  if (ThisId == variantId) { 
                    $this.removeClass('is__active'); 
                   $(this).find('.drawer_remove_button').click();
                   }
                });  
            } else { 
                $this.addClass('is__active');
                var itemdata = {
                  title: productTitle,
                  url:productUrl,
                  price: productPrice,
                  itemprice:itemPrice,
                  color:productAddOptions,
                  Image: productImage,
                  id: variantId,
                  ProductID : productId,
                  ProductSKU : productSku,
                  quantity: 1
                };
                Product_array.push(itemdata);
                localStorage.setItem("Swag_Pack", JSON.stringify(Product_array));
                localdatagrid();
          }
  });

   function localdatagrid() {
      if(localStorage.getItem('Swag_Pack')) {
          $(document).find("[data-drawer-target] #packdrawerListRoot").html('');
          var get_array_data = JSON.parse(localStorage.getItem("Swag_Pack"));
          $.each(get_array_data, function(index, value){
             var title = value.title;
             var productImage = value.Image;
             var productPrice = value.price;
             var product_id = value.ProductID;
             var product_sku = value.ProductSKU;
             var variant_id = value.id;
             var quantity = value.quantity;
             var productUrl = value.url;
             var productAddOptions = value.color;
             var itemprice = value.itemprice;
              if(productAddOptions){
                productAddOptions = '<p class="drawer_varient" data-product-color="'+productAddOptions+'"><strong>Color: </strong>'+productAddOptions+'</p>'
              }
             let product_div =  $(document).find("[data-drawer-target] #packdrawerListRoot");
             var product_html = '<li class="pack-drawerList-items" data-productId="'+product_id+'" data-variantId="'+variant_id+'" data-product-sku="'+product_sku+'"><a class="drawerList-itemAction" href="'+productUrl+'"><div class="drawer_items_img"><img src="'+productImage+'" alt="image"></div>'+ 
             '<div class="drawer_items-info"><p class="drawer_title">'+title+'</p><p class="drawer_price"><strong>Price: </strong><span class="drawer_item_price" data-price="'+itemprice+'">'+productPrice+'</span></p>'+productAddOptions+
             '<p class="drawer_item_perQty"><strong>Qty per pack: </strong> 01</p></div></a><div class="drawer_item_remove"><button type="button" class="drawer_remove_button" data-variant-id="'+variant_id+'">'+
             '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg></button></div></li>'
             product_div.append(product_html);  
          });

          $('.pack-drawer--root[data-drawer-target]').addClass('is__visible');

           var item_price = 0; var counterIndex = 0; 
            $(document).find('#packdrawerListRoot li.pack-drawerList-items').each(function(){
              item_price += parseFloat($(this).find('.drawer_item_price').data('price'))/100;  
               counterIndex += 1;
            }); 
            $(document).find('.pack--total__amount .pack--total-money').text('$'+item_price.toFixed(2));
            if (counterIndex == 0){
              $('#swagPackRequest_mockup').hide().removeClass('is__visible');
              $('.drawer--checkoutButton').removeClass('is__active'); 
              $('#drawer-name').removeClass('is__visible'); 
            }
      }
  }


   
    if(localStorage.getItem('Swag_Pack')) {
         var get_array_data = JSON.parse(localStorage.getItem("Swag_Pack"));
         if(get_array_data.length > 0){
             $.each(get_array_data, function(index, value){
                 var title = value.title;
                 var productImage = value.Image;
                 var productPrice = value.price;
                 var product_id = value.ProductID;
                 var product_sku = value.ProductSKU;
                 var variant_id = value.id;
                 var quantity = value.quantity;
                 var productUrl = value.url;
                 var productAddOptions = value.color;
                 var itemprice = value.itemprice;
               
                    var itemdata = {
                        title: title,
                        url:productUrl,
                        price: productPrice,
                        itemprice:itemprice,
                        color:productAddOptions,
                        Image: productImage,
                        id: variant_id,
                        ProductID : product_id,
                        ProductSKU: product_sku, 
                        quantity: 1
                    };
                    Product_array.push(itemdata);
                    localStorage.setItem("Swag_Pack", JSON.stringify(Product_array));
               
                  if(productAddOptions){
                    productAddOptions = '<p class="drawer_varient" data-product-color="'+productAddOptions+'"><strong>Color: </strong>'+productAddOptions+'</p>'
                   }
                 let product_div =  $(document).find("[data-drawer-target] #packdrawerListRoot");
                 var product_html = '<li class="pack-drawerList-items" data-productId="'+product_id+'" data-variantId="'+variant_id+'" data-product-sku="'+product_sku+'"><a class="drawerList-itemAction" href="'+productUrl+'"><div class="drawer_items_img"><img src="'+productImage+'" alt="image"></div>'+ 
                 '<div class="drawer_items-info"><p class="drawer_title">'+title+'</p><p class="drawer_price"><strong>Price: </strong><span class="drawer_item_price" data-price="'+itemprice+'">'+productPrice+'</span></p>'+productAddOptions+
                 '<p class="drawer_item_perQty"><strong>Qty per pack: </strong> 01</p></div></a><div class="drawer_item_remove"><button type="button" class="drawer_remove_button" data-variant-id="'+variant_id+'">'+
                 '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg></button></div></li>'
                 product_div.append(product_html);  
              });
             $('.pack-drawer--root[data-drawer-target]').addClass('is__visible');
    
             var item_price = 0; 
             $(document).find('#packdrawerListRoot li.pack-drawerList-items').each(function(){
                item_price += parseFloat($(this).find('.drawer_item_price').data('price'))/100;  
    
                   var ThisId = $(this).attr('data-variantid');
                   $(document).find('.itg_featured_collection .swagPack-collection-grid-item').each(function(){
                      var variantId = $(this).find('input.product-variant-id').val(); var $this = $(this); 
                      if (variantId == ThisId){   
                         $this.find('product-card button.productAddtocart').addClass('is__active'); 
                      } 
                  });
             }); 
             $(document).find('.pack--total__amount .pack--total-money').text('$'+item_price.toFixed(2)); 
         }
    }


     $(document).on('click', '.pack-drawerList-items .drawer_remove_button', function(evt) {
         evt.preventDefault();
            var newArray = []; Product_array = [];
            var $this = $(this);
            var removeID = $this.attr('data-variant-id');
            $(document).find('.itg_featured_collection .swagPack-collection-grid-item').each(function(){
                var ThisId = $(this).find('input.product-variant-id').val(); 
                if (ThisId == removeID) {  
                $(this).find('button.productAddtocart').removeClass('is__active');
                }
            }); 
       
          var getarray_data = JSON.parse(localStorage.getItem("Swag_Pack"));
          $.each(getarray_data, function( index, value){
             var getvarId = value.id;
             if(getvarId == removeID){
               delete getarray_data[index];
                var countitems = 0;
                $.each(getarray_data, function( key, value ) {
                  if(value == undefined && value == null){
                  }else{ 
                     var itemdata = {
                        title: value.title,
                        url: value.url,
                        price: value.price,
                        itemprice: value.itemprice,
                        color: value.color,
                        Image: value.Image,
                        id: value.id,
                        ProductID : value.ProductID,
                        ProductSKU : value.ProductSKU,
                        quantity: 1
                    };
                  
                    Product_array.push(itemdata);
                    newArray[countitems] = value;
                    countitems++;
                  }
                });
                localStorage.setItem("Swag_Pack", JSON.stringify(newArray));
                localdatagrid();
                return false;
             }
          });
    });

    $(document).on('change', 'select.selectColorOption', function() {
        var $this = $(this); 
        var variantId = $(this).find(":selected").attr('data-id');
        var variantPrice = $(this).find(":selected").attr('data-price');
        var variantTitle = $(this).find(":selected").val();
        $this.parents('product-card').find('product-price [data-aid="regular-price"]').text(variantPrice);
        $this.parents('product-card').find('input.product-variant-id').val(variantId);
          $(document).find('#packdrawerListRoot li.pack-drawerList-items').each(function(){
            var ThisId = $(this).attr('data-variantid');
             if(ThisId == variantId) {  
              $this.parents('product-card').find('button.productAddtocart').addClass('is__active'); 
             }else{ 
              $this.parents('product-card').find('button.productAddtocart').removeClass('is__active');
             }
          });
      
     });

      $(document).on('click', '#packQuantityRoot span.changeQuantity', function(evt) {
        evt.preventDefault();
        $('#packQuantityRoot').hide();  
        $('#selectQuantityboxroots').show(); 
     });
  
      $(document).on('click', '#selectQuantityboxroots button.selectQuantityDown', function(evt) {
        evt.preventDefault();
        $('#packQuantityRoot').show();  
        $('#selectQuantityboxroots').hide(); 
     });
  
   $(document).on('click', '#selectQuantityboxroots span.selectQuantityValue', function(evt) {
        evt.preventDefault();
        var thisValue = $(this).find('.spanQuantityValue').text(); 
        $('div#packQuantityRoot span.currentQuantity').text(thisValue)
        $('#selectQuantityboxroots').hide();  $('#packQuantityRoot').show(); 
     });
  
     $(document).on('click', '.pack-drawer--checkout .drawer--checkoutButton', function(evt) {
        evt.preventDefault();
        $(this).addClass('is__active'); 
        $('#swagPackRequest_mockup').show();
        $('#swagPackRequest_mockup').addClass('is__visible'),
        $("#swag__packRequestForm").slideDown(); 
        $(".swag__pack-request--contact").slideUp();
        $(".swag__pack-request--edit").removeClass('is_active'); 
   });
  
      $(document).on('click', '.buildSwagPack--nav #redirctBuildSwagPack', function(evt) {
        evt.preventDefault();
        $('#swagPackRequest_mockup').hide().removeClass('is__visible');
        $('.drawer--checkoutButton').removeClass('is__active'); 
        // $('#drawer-name').removeClass('is__visible'); 
      });
     $(document).on('click', '.pack-drawer--header span.closDrawerButton', function(evt) {
        evt.preventDefault();
        $('#swagPackRequest_mockup').hide().removeClass('is__visible');
        $('.drawer--checkoutButton').removeClass('is__active'); 
        $('#drawer-name').removeClass('is__visible'); 
      });
  
    $(document).on('click', 'button.swagPackContinue', function(evt) {
      evt.preventDefault();
       var findimg = $(document).find('#swagPack-input--primary').val();
       if(($(document).find('#swagPack-input--primary').val().split('\\').pop() == '') && ($(document).find('#swagPack-input--secondary').val().split('\\').pop() == '')){
          $(document).find('.swagPack-input-fieldHalf').focus();
          $(document).find('.swagPackInputfileButton').css("border", "dashed 2px #bc2e2a");
          return false;
       }else{
         $(document).find('.swagPackInputfileButton').css("border", "dashed 2px #CED1D6");
         $(".swag__pack-request--edit").addClass('is_active'); 
         $("#swag__packRequestForm").slideUp(); 
         $(".swag__pack-request--contact").slideDown();
       }
   });
   
   $(document).on('click', '.swag__pack-request--edit', function(evt) {
      evt.preventDefault();
      $(this).removeClass('is_active'); 
      $("#swag__packRequestForm").slideDown(); 
      $(".swag__pack-request--contact").slideUp();
   });

    $(document).on('change', '.swagPack-input-field-file input[type="file"]', function() {
        const fileName = $(this).val().split('\\').pop(); 
        $(this).parents('.swagPackInputfileButton').find('.file__name-1').hide();
        $(this).parents('.swagPackInputfileButton').find('.file__name-2').show(); 
        var parentRole = $(this).parents('.swagPackInputfileButton');
          const file = this.files[0]; 
          if (file) {
          const reader = new FileReader(); 
          reader.onload = function(e) {    
         parentRole.find('.swagPack-file--media').html(`<img src="${e.target.result}" alt="Preview" class="swagPack-file--img" width="100" />`);
          } 
          reader.readAsDataURL(file);
          } else {
          parentRole.find('.swagPack-file--media').html('');
        }
         $(document).find('.swagPackInputfileButton').css("border", "dashed 2px #CED1D6");
   });

    $(document).on('click', '.swag-packThanksubmission span.ThanksubmissionClose', function(evt) {
      evt.preventDefault();Product_array = [];
      $('.swag-packThanksubmission').hide(); 
      $('#swagPackRequest_mockup').hide().removeClass('is__visible'); 
      $('#drawer-name').removeClass('is__visible'); 
      $(document).find('button.productAddtocart').removeClass('is__active');  
     localStorage.removeItem("Swag_Pack");
    });
  
   $("#swag_form").submit(function(e) {
       e.preventDefault();

       var find_color = ''; var find_sku = ''; var swagpack = ''; var budgetperpack = ''; var certaindate = ''; var comments = ''; var primary_img = '';
       var secondary_img = ''; var fullname = ''; var email = ''; var company = ''; var phone = '';
     
       var form_data = new FormData();
       var TableData = new Array();
       $(document).find("ul#packdrawerListRoot li").each(function(index){
           var find_title = $(this).find('.drawer_title').text().trim();
           var find_sku = $(this).attr('data-product-sku');
           var find_img = $(this).find('.drawer_items_img img').attr('src');
           var find_color = $(this).find('.drawer_varient').attr('data-product-color');
           TableData[index] = {"title":find_title,"sku":find_sku,"img":find_img,"colordata":find_color}
       });
       var mainItem = {};
       mainItem['items']  = TableData;
       form_data.append("productdata", JSON.stringify(mainItem));
     
      var swagpack = $(document).find('#swagpack').val();
      var budgetperpack = $(document).find('#budgetperpack').val();
      var certaindate = $(document).find('#certaindate').val();
      var comments = $(document).find('#comments').val();

      var primary_img = $('#swagPack-input--primary').prop('files')[0];
      var secondary_img = $('#swagPack-input--secondary').prop('files')[0];

      var fullname = $(document).find('#fullname').val();
      var email = $(document).find('#email').val();
      var company = $(document).find('#company').val();
      var phone = $(document).find('#phone').val();

      form_data.append("swagpack", swagpack);
      form_data.append("budgetperpack", budgetperpack);
      form_data.append("certaindate", certaindate);
      form_data.append("comments", comments);
      form_data.append("primary_img", primary_img);
      form_data.append("secondary_img", secondary_img);
      form_data.append("fullname", fullname);
      form_data.append("email", email);
      form_data.append("company", company);
      form_data.append("phone", phone);

           $(document).find('.loader-bg').css("display", "flex");
           $.ajax({
              type: 'POST',
              url: 'https://dev.shopifyexperthelp.com/app/project_app/breakerone/getdata.php',
              data:form_data,
              contentType: false,
              cache: false,
              processData:false,
              success: function(response){
                $(document).find('.loader-bg').css("display", "none");
                $(document).find('.swag-packThanksubmission').show();
                $(document).find('#swagPackRequest_mockup').hide().removeClass('is__visible'); 
                $(document).find('#drawer-name').removeClass('is__visible'); 
                $(document).find('button.productAddtocart').removeClass('is__active'); 
                localStorage.removeItem("Swag_Pack");
                $('#swag_form')[0].reset();
                setTimeout(function() {
                   $(document).find('.swag-packThanksubmission').hide();
                }, 10000);
              }
          });
    });
  
}); 


// add target="_blank" to all non-internal text links
	$(function() {
	$('a').filter(function() {
		return this.hostname && this.hostname !== location.hostname;
	}).attr('target', '_blank');

    $('a').filter(function() {
		return this.hostname && this.hostname == location.hostname;
	}).attr('target', '_self');
});
